import React, { PropsWithChildren } from 'react'
import Box from '@mui/material/Box'

type Props = PropsWithChildren & {
  itemHeight?: string
  draggingIndex: number | null
  index: number
  offsets: number[]
}

const DraggableItemWrapper = React.forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const {
      itemHeight = '64px',
      draggingIndex,
      index,
      offsets,
      children,
    } = props

    return (
      <Box
        ref={ref}
        sx={{
          zIndex: draggingIndex === index ? 100 : 1,
          opacity: draggingIndex === index ? 0 : 1,
          position: 'relative',
          height: itemHeight,
        }}
      >
        <Box
          sx={{
            transition:
              draggingIndex !== null
                ? 'transform 200ms cubic-bezier(0.2, 0, 0, 1)'
                : undefined,
            transform:
              draggingIndex === index
                ? 'none'
                : `translateY(${offsets[index] || 0}px)`,
          }}
        >
          {children}
        </Box>
      </Box>
    )
  },
)

export { DraggableItemWrapper }
